<template>
    <div class="contact-item">
        <div class="icon-wrapper">
            <img :src="iconPath" :alt="label" class="contact-icon" loading="lazy" />
        </div>
        <div class="contact-info">
            <p class="contact-label">{{ label }}</p>
            <a v-if="href" :href="href" class="contact-value">{{ value }}</a>
            <p v-else class="contact-value">{{ value }}</p>
        </div>
    </div>
</template>

<script setup lang="ts">
interface Props {
    icon: 'phone' | 'email' | 'location'
    label: string
    value: string
    href?: string
    bgColor?: string
}

const props = withDefaults(defineProps<Props>(), {
    bgColor: '#ef4444'
})

const iconPath = computed(() => `/leaflypackaging-com/icons/${props.icon}.svg`)

const iconColor = computed(() => {
    const colors: Record<string, string> = {
        phone: '#ef4444',
        email: '#facc15',
        location: '#60a5fa'
    }
    return colors[props.icon] || props.bgColor
})
</script>

<style scoped lang="scss">
.contact-item {
    display: flex;
    align-items: center;
    margin-bottom: 0.75rem;

    &:last-of-type {
        margin-bottom: 0.1rem;
    }
}

.icon-wrapper {
    width: 24px;
    height: 24px;
    border-radius: 9999px;
    margin-right: 0.5rem;
    flex-shrink: 0;
    background-color: v-bind(iconColor);
    display: flex;
    align-items: center;
    justify-content: center;
}

.contact-icon {
    width: 80%;
    height: 80%;
    margin-top: 10%;
    margin-left: 10%;
}

.contact-info {
    .contact-label {
        font-size: 0.75rem;
        color: #d1d5db;
        margin-bottom: -0.25rem;
    }

    .contact-value {
        font-size: 0.875rem;
        color: #ffffff;
        white-space: nowrap;
        display: inline-flex;
        align-items: center;
        min-height: 32px;
        padding-top: 0.25rem;

        &:hover {
            color: #d1d5db;
        }
    }
}
</style>
